export const dashboardSummarizedData = state => {
}
export const mitelConnectionStatus = state => state.mitelConnectionStatus
export const mitelCallCode = state => state.mitelCallCode
export const mitelCallerName = state => state.mitelCallerName
export const mitelCallerNumber = state => state.mitelCallerNumber


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js